import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild,
    ElementRef
} from "@angular/core";
import { IdName } from "../domain/idname";
import { LookupService } from "../service/lookup.service";

@Component({
    selector: "app-dimension-picker",
    templateUrl: "./dimension-picker.component.html"
})
export class DimensionPickerComponent implements OnInit {
    constructor(private lookupService: LookupService) {}

    @Input() dimensionId: any;

    @Output() dimensionIdChange = new EventEmitter();

    @Input() dimension: string;

    @Output() dimensionChange = new EventEmitter();

    @Input() companyId: string;
    @Input() label: string;
    @Input() header: string;

    dimensionPickerVisible = false;

    dimensions: IdName[];

    selected: any;

    lastValidSelection: IdName;

    tableColumns: any[];

    ngOnInit() {
        this.tableColumns = [{ field: "name", header: "Name", width: "100%" }];

        this.lookupService
            .getIdName(`dimensions/${this.companyId}`)
            .then(objects => {
                this.dimensions = objects;

                if (this.dimensions && this.dimensions.length > 0 && this.dimensionId)
                {
                    var findDimension = this.dimensions.find(e => e.id == this.dimensionId);

                    if (findDimension)
                    {
                        this.selected = findDimension;
                        this.lastValidSelection = this.selected;
                        this.changeDimension(this.selected.code);
                        this.changeDimensionId(this.selected.id);
                    }
                }
            });
    }

    changeDimension(newValue) {
        this.dimension = newValue;
        this.dimensionChange.emit(newValue);
    }

    changeDimensionId(newValue) {
        this.dimensionId = newValue;
        this.dimensionIdChange.emit(newValue);
    }

    okClick() {
        this.lastValidSelection = this.selected;
        this.dimensionPickerVisible = false;
        this.changeDimension(this.selected.code);
        this.changeDimensionId(this.selected.id);
    }

    clear() {
        this.changeDimension('');
        this.changeDimensionId(null);
    }

    showDialog() {
        this.selected = this.lastValidSelection;
        this.dimensionPickerVisible = true;
    }
}
